import { useForm } from "@mantine/form";
import { Button, TextInput } from "@mantine/core";
import { updateNotification } from "../../utils/useNotification";
import { updateEmployeeById } from "../../api/employeeApi";
import { updateTerminalById } from "../../api/terminalApi";
import { validateRequired } from "../../utils/validations";

const TerminalUpdateForm = ({
  tablet,
  closeModal,
}: {
  tablet: any;
  closeModal: any;
}) => {
  const form = useForm({
    initialValues: {
      name: tablet?.name,
      location: tablet?.location,
    },
    validate: {
      name: validateRequired,
      location: validateRequired,
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      const { data }: any = await updateTerminalById({
        id: tablet?._id,
        updates: values,
      });
      updateNotification(data?.success);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      closeModal();
    }
  };

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
      onSubmit={form.onSubmit(handleSubmit)}
    >
      <TextInput
        label="Tablet İsmi"
        radius={10}
        size="md"
        {...form.getInputProps("name")}
      />
      <TextInput
        label="Tablet Konumu"
        radius={10}
        size="md"
        {...form.getInputProps("location")}
      />
      <Button
        type="submit"
        color="#5C26FF"
        radius={10}
        disabled={!form.isDirty()}
      >
        Güncelle
      </Button>
    </form>
  );
};

export default TerminalUpdateForm;
